// removed by extract-text-webpack-plugin
module.exports = {"modal":"index__modal___c8SFw","inline":"index__inline___23vMg"};


//////////////////
// WEBPACK FOOTER
// ./src/components/molecules/Modal/index.css
// module id = 994
// module chunks = 37